import { Box, Button } from "@mui/material";
import { React, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  approveMultiple,
  getQuotaForApproval,
  lockUnlockMultiple,
  setState,
} from "./quotaApprovalSlice";


export default function ButtonGroup() {
    
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const dispatch = useDispatch();
  const state = useSelector((store) => store.quota);
  const {
    selectedRowsselected,
    selectedRows,
    quotaForApproval,
    quotaForApprovalTable,
    selectedCountryID,
    selectedPeriod,
    selectedQuotaStatus,
    searchText,
    isCheckboxChecked,
  } = state;

  function search() {
    dispatch(setState("quotaCustomerBreakdown", null));
    dispatch(setState("quotaDetailsTable", null));
    dispatch(setState("rejectSelectedComment", ""));
    dispatch(setState("selectedRows", []));
    const logedUser = JSON.parse(localStorage.getItem("data"));
    const countryId = selectedCountryID;
    const period = selectedPeriod;
    const quotaStatus = selectedQuotaStatus;

    const obj = {
      countryId,
      period,
      quotaStatus,
      logedUser,
      searchText: searchText,
    };
    dispatch(getQuotaForApproval(obj));
  }

  // function approveSelected() {
  //   debugger;
  //   const user = JSON.parse(localStorage.getItem("data"));
  //   let quotaList = [];
  //   for (let i = 0; i < selectedRows.length; ++i) {
  //     const id = quotaForApprovalTable.rows[selectedRows[i]].quotaId;
  //     console.log(id);
  //     const quota = quotaForApproval.find((item) => item.quotaId === id);
  //     console.log(quota);
  //     const obj = {
  //       ...quota,
  //       user,
  //     };
  //     quotaList.push(obj);
  //   }
  //   console.log("Approve_Quota_ApproveSelected", quotaList);
  //   dispatch(approveMultiple(quotaList)).then(() => {
  //     search();
  //   });
  // }

  function approveSelected() {
    const user = JSON.parse(localStorage.getItem("data"));
    let qtaLst = [];
    for (let i = 0; i < selectedRowsselected.length; ++i) {
      const quota = quotaForApproval.find(
        (item) => item.quotaId === selectedRowsselected[i].quotaId
      );
      console.log(quota);
      const obj = {
        ...quota,
        user,
      };
      qtaLst.push(obj);
    }
    console.log("Approve_Quota_ApproveSelected", qtaLst);
    dispatch(approveMultiple(qtaLst)).then(() => {
      search();
      dispatch(setState("isCheckboxChecked", false));
    });
  }

  function lockUnlockSelected() {
    const user = JSON.parse(localStorage.getItem("data"));
    let quotaList = [];
    for (let i = 0; i < selectedRowsselected.length; ++i) {
      const quota = quotaForApproval.find(
        (item) => item.quotaId === selectedRowsselected[i].quotaId
      );
      console.log(quota);
      const obj = {
        ...quota,
        user,
      };
      quotaList.push(obj);
    }
    console.log("Approve_Quota_ApproveSelected", quotaList);
    dispatch(lockUnlockMultiple(quotaList)).then(() => {
      search();
      dispatch(setState("isCheckboxChecked", false));
    });
  }  

  // function lockUnlockSelected() {
  //   const user = JSON.parse(localStorage.getItem("data"));
  //   let quotaList = [];
  //   for (let i = 0; i < selectedRows.length; ++i) {
  //     const id = quotaForApprovalTable.rows[selectedRows[i]].quotaId;
  //     console.log(id);
  //     const quota = quotaForApproval.find((item) => item.quotaId === id);
  //     console.log(quota);
  //     const obj = {
  //       ...quota,
  //       user,
  //     };
  //     quotaList.push(obj);
  //   }
  //   console.log("Approve_Quota_ApproveSelected", quotaList);
  //   dispatch(lockUnlockMultiple(quotaList)).then(() => {
  //     search();
  //   });
  // }

  function openRejectionModal() {
    dispatch(setState("rejectSelModalOpen", true));
  }

  function openApproveWithCommentModal() {
    dispatch(setState("appMulWithCommentModal", true));
  }

  return (
    quotaForApprovalTable && (
      <Box
        sx={{
          mt: 2,
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
        }}
      >
        <Button
          className="disabled"
          sx={{
            bgcolor: "darkred.light",
            color: "white.main",
            textTransform: "none",
            fontWeight: "bold",
            mt: 1,
            ml:2,
            "&:hover": {
            bgcolor: "darkred.main",
            color: "white.main",
            },
         }}
          disabled={selectedRows.length === 0 || !isRestrictedAccess}
          onClick={approveSelected}
        >
          Approve Selected
        </Button>

        <Button
          className="disabled"
          sx={{
            bgcolor: "darkred.light",
            color: "white.main",
            textTransform: "none",
            fontWeight: "bold",
            mt: 1,
            ml:2,
            "&:hover": {
            bgcolor: "darkred.main",
            color: "white.main",
            },
         }}
          disabled={selectedRows.length === 0 || !isRestrictedAccess}
          onClick={openApproveWithCommentModal}
        >
          Approve With Comments Selected
        </Button>

        <Button
          className="disabled"
          sx={{
            bgcolor: "darkred.light",
            color: "white.main",
            textTransform: "none",
            fontWeight: "bold",
            mt: 1,
            ml:2,
            "&:hover": {
            bgcolor: "darkred.main",
            color: "white.main",
            },
         }}
          disabled={selectedRows.length === 0 || !isRestrictedAccess}
          onClick={openRejectionModal}
        >
          Reject Selected
        </Button>

        <Button
          className="disabled"
          sx={{
            bgcolor: "darkred.light",
            color: "white.main",
            textTransform: "none",
            fontWeight: "bold",
            mt: 1,
            ml:2,
            "&:hover": {
            bgcolor: "darkred.main",
            color: "white.main",
            },
         }}
          disabled={selectedRows.length === 0 || !isRestrictedAccess}
          onClick={lockUnlockSelected}
        >
          Lock/Unlock Selected
        </Button>
      </Box>
    )
  );
}
